import { Directive, ElementRef, HostBinding, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { RbacService } from '../../services/rbac.service';
import { Permission } from '../../lib/rbac.config';

@Directive({ 
  selector: '[appDisableWithoutPermission]', 
  exportAs: 'appDisableWithoutPermission'
})
export class DisableWithoutPermissionDirective implements OnInit, OnDestroy {
  @Input('appDisableWithoutPermission') permission!: Permission | Permission[];
  @Input() tooltipText =
    'You are not allowed to modify here. Please contact an admin if you need assistance.';

  isDisabled = false;

  @HostBinding('style.opacity') get opacity() { return this.isDisabled ? 0.4 : null; }
  @HostBinding('style.cursor') get cursor() { return this.isDisabled ? 'not-allowed' : null; }
  @HostBinding('attr.aria-disabled') get ariaDisabled() { return this.isDisabled ? 'true' : null; }

  constructor(
    private rbac: RbacService,
    private el: ElementRef<HTMLElement>,
    @Optional() private tooltip: MatTooltip, // sibling directive on the same host — optional in case someone forgets [matTooltip]
  ) {}

  ngOnInit(): void {
    const allowed = Array.isArray(this.permission)
      ? this.rbac.hasAnyPermission(this.permission)
      : this.rbac.hasPermission(this.permission);

    this.isDisabled = !allowed;

    if (this.tooltip) {
      this.tooltip.message = this.isDisabled ? this.tooltipText : '';
      this.tooltip.disabled = !this.isDisabled;
      this.tooltip.position = 'above';
    }

    if (this.isDisabled) {
      this.el.nativeElement.addEventListener('click', this.blockClick, true); // capture phase — runs before (click) bindings
    }
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('click', this.blockClick, true);
  }

  private blockClick = (event: Event): void => {
    event.stopImmediatePropagation();
    event.preventDefault();
  };
}
